/** Shared styles for the time-limited “New” alert chip (#5DC54F = theme `positive`). */
export const COMMAND_CENTER_ALERT_NEW_BADGE_CLASSNAME =
  "rounded bg-positive px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white md:text-[10px]";
